import './scss/main.scss'
import sgSelect from './js/sgSelect'
import initRecuitingMap from './js/node_recruiting_map'
import initContactList from './js/node_contact_list'
import initSalesPartnerOverlay from './js/node_sales_partner_overlay'
import initContactAreaLocations from './js/contact_area_locations.js'
import initOpenInModal from './js/open_in_modal.js'
import initRecruitingMapOnly from './js/node_recruiting_map_only.js'
import setMenuState from './js/mobile_menu_state.js'
import initSwitchBar from './js/node_switch_bar.js'

$(function() {
  sgSelect($)
  initRecuitingMap($)
  initContactList($)
  initSalesPartnerOverlay($)
  initContactAreaLocations($)
  initOpenInModal($)
  initRecruitingMapOnly($)
  setMenuState($)
  initSwitchBar($)

  $('.sg.select').sgSelect()
})



// WEBPACK FOOTER //
// app/javascript/sg/index.js